module.exports = __webpack_public_path__ + "img/logo.3bf61c5b.png";